module.exports = __webpack_public_path__ + "img/in_progress_pickup.25555677.svg";